import React from "react";
export var FormField = function (_a) {
    var children = _a.children, label = _a.label, errorLabel = _a.errorLabel, helpLabel = _a.helpLabel, htmlFor = _a.htmlFor, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("fieldset", { className: "pt-4 " + className },
        React.createElement("label", { className: "block " + (errorLabel ? "text-red-600 font-bold" : ""), htmlFor: htmlFor }, label),
        errorLabel && React.createElement("span", { className: "text-red-600" }, errorLabel),
        children,
        helpLabel && React.createElement("span", null, helpLabel)));
};
//# sourceMappingURL=FormField.js.map